import script from "./DashboardTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardTable.vue?vue&type=script&setup=true&lang=ts"

import "./DashboardTable.vue?vue&type=style&index=0&id=02811304&lang=scss"

const __exports__ = script;

export default __exports__